import { NotFoundBlockWrapper, NotFoundText, NotFoundTitle } from './styles'

interface NotFoundBlockProps {
  imgSrc?: string
  title?: string
  text?: string
}

function NotFoundBlock({ imgSrc, title, text }: NotFoundBlockProps) {
  return (
    <NotFoundBlockWrapper>
      <img src={imgSrc} alt="" />
      <NotFoundTitle>{title}</NotFoundTitle>
      <NotFoundText>{text}</NotFoundText>
    </NotFoundBlockWrapper>
  )
}

export default NotFoundBlock
